import React from 'react'
import Breadcrumbs from './breadCrumbs/breadCrumbs'
import LeftSection from './leftSection'
import RightSection from './rightSection'
import DownloadBrochure from './rightSection/DownloadBrochure'
import MoreDetailsSection from './leftSection/moreDetails/MoreDetails'
import { Outlet, useLocation, useParams } from 'react-router-dom'
import useFetch from '../../../hooks/useFetch'
import { getPropertyById } from '../../../services/propertyService'
import MapView from './rightSection/mapView'
import LoadingComponent from '../../../Components/LoadingComponent/loading'
import ShowPropertyGalleryPage from '../showGallery/showGallery'

const PropertyDetailPage = () => {
    const {propertyId} = useParams()

    const location = useLocation();

    const { data, loading, error:fetchingError } = useFetch(
      () => getPropertyById(propertyId),
      [propertyId]
  );

  console.log("daeddaata",data)


  if (loading) {
    return (
            <LoadingComponent />
    );
}



if (fetchingError) {
    return (
        <div className="flex justify-center items-center h-screen text-red-500">
            Error fetching property details.
        </div>
    );
}

const propertyData = data?.property || null;


  // Check if the user is on a nested route (gallery or imageswithdetail)
  const isNestedRoute =
    location.pathname.includes("/gallery") ||
    location.pathname.includes("/imageswithdetail");


  return (
    <div className='pt-[150px] bg-[#f5f5f5]'>
       {isNestedRoute ? (
        // Show only nested component if user is on a nested route
        <Outlet context={{ propertyData: propertyData }} />
      ) : (
        // Show full property detail page if on main route
        <>
          <Breadcrumbs propertyData={propertyData} />
          <div className="flex flex-col lg:flex-row ">
            <div className="w-full lg:w-[70%] min-h-screen">
              <LeftSection propertyData={propertyData} />
            </div>
            <div className="sm:w-[2%] "></div>
            <div className="w-full lg:w-[25%] px-2 sm:px-0">
              <RightSection
                postedByData={propertyData?.postedBy}
                propertyId={propertyId}
              />
              {propertyData?.brochure && <DownloadBrochure />}
              <MapView locationDetails={propertyData?.locationDetails} />
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default PropertyDetailPage
